type TTeamWithMembers = { Members: Array<{ id: string }> };

export const withoutTeamMembers = <T extends TTeamWithMembers>(
  team: T | undefined,
  removedMemberIds: readonly string[],
): T | undefined => {
  if (!team || removedMemberIds.length === 0) {
    return team;
  }

  const removed = new Set(removedMemberIds);

  return { ...team, Members: team.Members.filter((member) => !removed.has(member.id)) };
};
